import Cookies from "js-cookie";
import { getEndpoints } from "../utils/ApiContext";

const fetchWithAuth = async (url, options = {}) => {
  let headers = options.headers || {};

  const username = Cookies.get("username");
  let accessToken = Cookies.get("accessToken"); // This token can be updated with the refresh token
  const refreshToken = Cookies.get("refreshToken");
  const expirationDate = Cookies.get("expirationDate");

  if (accessToken && expirationDate) {
    const expirationTime = new Date(expirationDate).getTime();
    const now = new Date().getTime();

    const isAboutToExpireOrExpired = (expirationTime - now) < (5 * 60 * 1000) || now >= expirationTime // less than 5 minutes

    if (isAboutToExpireOrExpired && refreshToken) {
      try {
        // Attempt to refresh the token
        const endpoints = await getEndpoints();
        const refreshResponse = await fetch(endpoints.API_LOGIN, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'username': username,
            'refresh_token': refreshToken,
          }),
        });

        if (!refreshResponse.ok) {
          throw new Error('Failed to refresh token');
        }

        const refreshData = await refreshResponse.json();
        const { AccessToken, IdToken, ExpiresIn } = refreshData;
        const newExpirationDate = new Date(new Date().getTime() + ExpiresIn * 1000);

        Cookies.set("accessToken", AccessToken, { expires: newExpirationDate });
        Cookies.set("idToken", IdToken, { expires: newExpirationDate });
        Cookies.set("expirationDate", newExpirationDate.toISOString(), { expires: newExpirationDate });

        // Update the local accessToken variable
        accessToken = AccessToken;

      } catch (error) {
        console.error("Token refresh failed:", error);
        Cookies.remove("username");
        Cookies.remove("accessToken");
        Cookies.remove("idToken");
        Cookies.remove("refreshToken");
        Cookies.remove("expirationDate");
        window.location.href = "/login";

        throw error;
      }
    }
  }

  if (accessToken){
    headers.Authorization = `Bearer ${accessToken}`;
  }

  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const finalOptions = { ...options, headers };

  // Reactive check: If the request fails with a 401, redirect to login
  const response = await fetch(url, finalOptions);

  if (response.status === 401) {
    Cookies.remove("accessToken");
    Cookies.remove("idToken");
    Cookies.remove("refreshToken");
    Cookies.remove("expirationDate");
    window.location.href = "/login";
    throw new Error('Unauthorized request, session invalid.');
  }

  return response;
};

export default fetchWithAuth